export const ActionType = {
  GET_COUNTRIES: 'GET_COUNTRIES',
  TIMEZONE_LIST: 'TIMEZONE_LIST',
  GET_EASTERN_EUROPE_COUNTRIES: 'GET_EASTERN_EUROPE_COUNTRIES',
};

export const REGIONS = {
  LATAM: 'LATAM',
  EASTERN_EUROPE: 'Eastern Europe',
};

export class Country {
  id = 0;

  label = '';

  name = '';

  code = '';

  currency = '';

  dialCode = '';

  region = '';
}
